module.exports = __webpack_public_path__ + "static/media/reset.015046d3.svg";